import { ClaioSchemaItem } from ".";

export class ClaioSchemaGroup {
  name: string;
  items: ClaioSchemaItem[]; 
}
